import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileXlsX.tsx
const IconFileXlsX = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h13v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#5eb557",
			fillRule: "evenodd",
			d: "M6 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm5 6.09v-4.188h.911v3.378h1.596v.81zm-1.614 0h1.056L9.08 12.942l1.29-2.04h-.984l-.828 1.416H8.54l-.816-1.416H6.662l1.278 2.022-1.344 2.166h.984l.882-1.542h.018zm6.15.072q-.552 0-.935-.186a2.2 2.2 0 0 1-.654-.492l.6-.606q.426.48 1.05.48.336 0 .498-.138a.46.46 0 0 0 .162-.366.43.43 0 0 0-.096-.288q-.096-.12-.39-.162l-.414-.054q-.666-.084-.978-.402-.306-.318-.306-.846 0-.282.108-.516t.306-.402q.204-.168.492-.258.294-.096.666-.096.474 0 .834.15t.618.438l-.606.612q-.15-.174-.366-.282a1.1 1.1 0 0 0-.534-.114q-.306 0-.456.108a.35.35 0 0 0-.15.3q0 .216.114.312.12.096.384.138l.414.066q.648.102.96.402.312.294.312.84 0 .3-.108.552a1.2 1.2 0 0 1-.318.432q-.204.18-.51.282a2.3 2.3 0 0 1-.696.096m4.813-.072h1.056l-1.362-2.148 1.29-2.04h-.984l-.828 1.416h-.018l-.816-1.416h-1.062l1.278 2.022-1.344 2.166h.984l.882-1.542h.018z",
			clipRule: "evenodd"
		})
	]
});
var IconFileXlsX_default = forwardRef(IconFileXlsX);
//#endregion
export { IconFileXlsX_default as default };
